import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IDeviceSensor, defaultValue } from 'app/shared/model/device-sensor.model';
import { IDeviceSensorDTO } from 'app/shared/model/dto/sensor-device-dto.model';

const initialState: EntityState<IDeviceSensorDTO> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/device-sensors';

// Actions


export const getSensorsByDeviceTruckID = createAsyncThunk(
  'deviceSensorDTO/fetch_deviceSensors_list',
  async (deviceTruckID: string) => {
    const response = await axios.get(`${apiUrl}-by-deviceTruckImplement-id/${deviceTruckID}`);
    return response.data;
  }
);
export const getSensorsByDeviceID = createAsyncThunk(
  'deviceSensorDTO/fetch_deviceSensors_list', async (deviceTruckID: string) => {
  const requestUrl = `${apiUrl}-by-deviceTruckImplement-id/${deviceTruckID}`;
  return axios.get<IDeviceSensorDTO[]>(requestUrl);
});


// slice

export const DeviceSensorSlice = createEntitySlice({
  name: 'deviceSensorDTO',
  initialState,
  extraReducers(builder) {
    builder
      
      .addMatcher(isFulfilled(getSensorsByDeviceID), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
        };
      })
      
      .addMatcher(isPending(getSensorsByDeviceID), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
     
  },
});

export const { reset } = DeviceSensorSlice.actions;

// Reducer
export default DeviceSensorSlice.reducer;
